<template lang="pug">
  main
    .columns.is-multiline
      .column.is-3(v-for="a in asignados")
        CardArticulo_Asign(:articulo="a" :disabled="getIsDisabled(a)" :key="a.id" @asignarArticulo="selectArticulo")
</template>

<script>
  import CardArticulo_Asign from './CardArticulo_Asign'
  export default {
    name: 'ListAsignaciones',
    components: { CardArticulo_Asign },
    props: {
      asignados: {
        type: Array,
        default: []
      },
      nuevos: {
        type: Array,
        default: []
      },
    },
    methods: {
      selectArticulo(art) {
        this.$emit('articulo_select', art)
      },
      getIsDisabled (art) {
        var indexOfArt = this.nuevos.findIndex(newA => newA.id_articulo === art.id_articulo)
        if (indexOfArt >=0) {
          return true
        } else {
          return false
        }
      }
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/ListAsignaciones.vue